import React from "react";
import { Row, Col } from "react-bootstrap";
import { H2, H4 } from "@irati/ui/src/Typography";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import img404 from "@irati/ui/images/deal-404.svg";
import { FormattedMessage } from "@irati/utils/lang";
import DealStatus from "@irati/deals/constants/status";
import StyledStatusContainer from "./styled/Container";
import StyledImg from "./styled/Img";
import Card from "./styled/Card";
var RequireDealStatusOn = function (_a) {
    var deal = _a.deal, children = _a.children;
    var dealStatus = deal === null || deal === void 0 ? void 0 : deal.status;
    var dealStatusVisible = [DealStatus.ON, DealStatus.TEST, DealStatus.UNAVAILABLE].indexOf(dealStatus) >= 0;
    return (React.createElement("div", null,
        dealStatusVisible && children,
        !dealStatusVisible && (React.createElement(StyledStatusContainer, null,
            React.createElement(Row, null,
                React.createElement(Col, { md: 8, mdOffset: 2 },
                    React.createElement(Card, null,
                        React.createElement(StyledImg, { src: img404, alt: "Perk not available" }),
                        (function () {
                            switch (dealStatus) {
                                case DealStatus.OFF:
                                    return (React.createElement("span", null,
                                        React.createElement(H2, null,
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.firstText" }),
                                            React.createElement("br", null),
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.notAvailable" }))));
                                case DealStatus.HIDDEN:
                                    return (React.createElement("span", null,
                                        React.createElement(H2, null,
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.firstText" }),
                                            React.createElement("br", null),
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.tempUnavailableTitle" })),
                                        React.createElement(H4, null,
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.tempUnavailableDesc" }))));
                                default:
                                    return (React.createElement("span", null,
                                        React.createElement(H2, null,
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.firstText" }),
                                            React.createElement("br", null),
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.notFoundTitle" })),
                                        React.createElement(H4, null,
                                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.error.notFoundDesc" }))));
                            }
                        })(),
                        React.createElement(ButtonRouterLink, { primary: true, to: "/" },
                            React.createElement(FormattedMessage, { id: "perks.components.requireDealStatus.allPerksButton" })))))))));
};
export default RequireDealStatusOn;
